export enum UserRole {
    TEACHER = 'TEACHER',
    PARENT = 'PARENT',
    SCHOOL_ADMIN = 'SCHOOL_ADMIN',
    ACCOUNTANT = 'ACCOUNTANT',
    SUPER_ADMIN = 'SUPER_ADMIN',
}

export const ROLE_REDIRECT_PATH: Record<UserRole, string> = {
    [UserRole.TEACHER]: '/dashboard/teacher/today',
    [UserRole.PARENT]: '/dashboard/parent/home',
    [UserRole.SCHOOL_ADMIN]: '/dashboard/admin/dashboard',
    [UserRole.ACCOUNTANT]: '/dashboard/admin/dashboard',
    [UserRole.SUPER_ADMIN]: '/dashboard/super-admin/schools',
}

export const ROLE_BASE_PATH: Record<UserRole, string> = {
    [UserRole.TEACHER]: '/dashboard/teacher',
    [UserRole.PARENT]: '/dashboard/parent',
    [UserRole.SCHOOL_ADMIN]: '/dashboard/admin',
    [UserRole.ACCOUNTANT]: '/dashboard/admin',
    [UserRole.SUPER_ADMIN]: '/dashboard/super-admin',
}
